module.exports = __webpack_public_path__ + "img/logo.8097c4b9.jpg";